import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const advP6Churned: FaireAdvertiserProfileEntity = {
  token: "adv_p6_churned",
  type: "advertiserProfile",
  archetype: "churned-with-history",
  displayName: "Lustre & Co.",
  brandToken: "b_adv_p6_churned",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "STOPPED",
  tenureMonths: 28,
  budget: {
    totalBudgetDollars: 2400,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 275,
    numReorderConversions: 87,
    numTotalConversions: 362,
    totalAdsSalesDollars: 146679,
    newCustomerAdsSalesDollars: 120974,
    reorderAdsSalesDollars: 25705,
    totalAdsSpendDollars: 43653,
    newCustomerAdsSpendDollars: 39906,
    reorderAdsSpendDollars: 3747,
    newCustomerBestEstimateFirstYearRoas: 3.03,
    reorderRoas: 6.86,
    combinedFirstYearRoas: 3.36,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 1800,
      maxRecommendedBudgetDollars: 2700,
    },
    reorder: {
      minRecommendedBudgetDollars: 600,
      maxRecommendedBudgetDollars: 900,
    },
  },
  campaignTokens: ["camp_p6_churned_new", "camp_p6_churned_reorder"],
  overviewPerformancePeriodTokens: [
    "perf_p6_churned_ovw_202506",
    "perf_p6_churned_ovw_202507",
    "perf_p6_churned_ovw_202508",
    "perf_p6_churned_ovw_202509",
    "perf_p6_churned_ovw_202510",
    "perf_p6_churned_ovw_202511",
    "perf_p6_churned_ovw_202512",
    "perf_p6_churned_ovw_202601",
    "perf_p6_churned_ovw_202602",
    "perf_p6_churned_ovw_202603",
    "perf_p6_churned_ovw_202604",
    "perf_p6_churned_ovw_202605",
    "perf_p6_churned_ovw_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
